<template>
    <div>
        <div style="margin-bottom:15px;margin-top:15px;" class="col-lg-12 text-center">
            <div v-for="model in question.answers" v-bind:key="model.uid">
                <div>
                    <label
                            :for="question.uid" v-bind:class="{ selected: model.selected }">
                    </label>

                    <audio-recorder
                            :attempts="5"
                            :time="1"
                            :after-recording="onRecordSelected"
                            :select-record="onRecordSelected"
                            :mode="'minimal'"
                    />
                </div>

                <input type="hidden" class="form-control" :name="question.uid" v-bind:id="question.uid">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'audio-record',
        props: ['question', 'canAudio'],
        data() {
            return {}
        },
        methods: {
            onRecordSelected(data) {
                if (data.blob) {
                    var reader = new FileReader();
                    reader.readAsDataURL(data.blob);
                    reader.onloadend = () => {
                        document.getElementById(this.question.uid).value = reader.result;
                    }
                }
            }
        }
    }
</script>